<template>
  <div class="verify-wrapper">
    <h3 class="verify-title">
      <i class="el-icon-search"></i>
      招采金服保函查验
    </h3>
    <el-input placeholder="请输入保函编号" v-model="text" class="search-group">
      <el-button slot="append" @click="serach">查询</el-button>
    </el-input>
    <div class="verify-tip" v-loading="loading">
      <i class="el-icon-warning-outline tip-icon"></i>
      保函查验功能目前支持银行保函、电子担保保函、保险保函的查验
    </div>
    <div class="resultInfo" v-if="resultShow">
      <div class="formDiv">
        <div class="projectName fw-800">
          <span style="margin-right: 20px">项目名称: </span
          ><span>{{ guaranteeFormat.projectName }}</span>
        </div>
        <el-form
          :model="guaranteeFormat"
          label-width="100px"
          class="formPage el-viewform"
        >
          <el-form-item label="保险单号" v-if="guaranteeType === '7000'">
            <span class="info-text">{{ guaranteeFormat.guaranteeNo }}</span>
          </el-form-item>
          <el-form-item
            label="保函编号"
            v-if="guaranteeType === '9600' || isPerformance"
          >
            <span class="info-text">{{ guaranteeFormat.guaranteeNo }}</span>
          </el-form-item>
          <el-form-item label="验真码" v-if="guaranteeType === '8000'">
            <span class="info-text">{{ guaranteeFormat.guaranteeNo }}</span>
          </el-form-item>
          <el-form-item label="项目编号">
            <span class="info-text">{{ guaranteeFormat.projectCode }}</span>
          </el-form-item>
          <el-form-item label="招标人" v-if="guaranteeType === '9600'">
            <span class="info-text">{{
              guaranteeFormat.tenderCompanyName
            }}</span>
          </el-form-item>
          <el-form-item label="受益人" v-if="isPerformance">
            <span class="info-text">{{
              guaranteeFormat.tenderCompanyName
            }}</span>
          </el-form-item>
          <el-form-item label="受益人" v-if="guaranteeType === '8000'">
            <span class="info-text">{{
              guaranteeFormat.tenderCompanyName
            }}</span>
          </el-form-item>
          <el-form-item label="被保人" v-if="guaranteeType === '7000'">
            <span class="info-text">{{
              guaranteeFormat.tenderCompanyName
            }}</span>
          </el-form-item>
          <el-form-item label="公司名称" v-if="guaranteeType === '7000'">
            <span class="info-text">{{
              guaranteeFormat.bidderCompanyName
            }}</span>
          </el-form-item>
          <el-form-item label="被保证人" v-else-if="isPerformance">
            <span class="info-text">{{
              guaranteeFormat.bidderCompanyName
            }}</span>
          </el-form-item>
          <el-form-item label="投标人" v-else>
            <span class="info-text">{{
              guaranteeFormat.bidderCompanyName
            }}</span>
          </el-form-item>
          <el-form-item
            label="保险额度"
            v-if="guaranteeType === '7000' && !isPerformance"
          >
            <span class="info-text">{{ guaranteeFormat.guaranteeAmount }}</span>
          </el-form-item>
          <el-form-item label="保证金金额" v-else-if="!isPerformance">
            <span class="info-text">{{ guaranteeFormat.guaranteeAmount }}</span>
          </el-form-item>
          <el-form-item
            label="投保期限"
            v-if="guaranteeType === '7000' && !isPerformance"
          >
            <span class="info-text">{{ guaranteeFormat.validityPeriod }}</span>
          </el-form-item>
          <el-form-item label="投标有限期" v-else-if="!isPerformance">
            <span class="info-text">{{ guaranteeFormat.validityPeriod }}</span>
          </el-form-item>
          <el-form-item
            label="开标日期"
            v-if="guaranteeType === '7000' && !isPerformance"
          >
            <span class="info-text">{{
              guaranteeFormat.guaranteeStartDate
            }}</span>
          </el-form-item>
        </el-form>
      </div>
      <div style="border: 1px solid #dedede; width: 100%; min-height: 200px">
        <PDFRender :url="guaranteeFormat.url"></PDFRender>
      </div>
    </div>
  </div>
</template>

<script>
import pdf from '@/components/pdf/pdf.vue'
import { queryVerifyByGuarantee, viewPerformanceRecord } from '@/api/verify'
import { isEmpty } from 'lodash'

export default {
  name: 'Verify', // 保函验真
  components: {
    PDFRender: pdf,
  },
  data() {
    return {
      text: '',
      guarantee: {},
      loading: false,
      isPerformance: false,
    }
  },
  computed: {
    resultShow() {
      const { guarantee, isPerformance } = this
      return (
        isPerformance ||
        (!isEmpty(guarantee.order?.bfeGuaranteeMain) &&
          !isEmpty(guarantee.order?.model))
      )
    },
    guaranteeType() {
      const { guarantee } = this
      console.log(guarantee)
      return guarantee.order?.bfeGuaranteeMain?.applyType
    },
    guaranteeFormat() {
      const { guarantee, guaranteeType, isPerformance } = this
      if (isPerformance) {
        return {
          ...guarantee,
          url: '/zcjf/base/file/download/' + guarantee.fileId,
        }
      }
      return {
        guaranteeNo: guarantee.guaranteeNo,
        projectCode: guarantee.order?.model?.projectCode,
        projectName: guarantee.order?.model?.projectName,
        tenderCompanyName: guarantee.order?.model?.tenderCompanyName,
        bidderCompanyName: guarantee.order?.model?.bidderCompanyName,
        guaranteeAmount: guarantee.order?.bfeGuaranteeMain?.guaranteeAmount,
        validityPeriod: guarantee.order?.model?.validityPeriod + '天',
        guaranteeStartDate:
          guarantee.order?.bfeGuaranteeMain?.guaranteeStartDate,
        url:
          guaranteeType === '7000'
            ? guarantee.order?.bfeGuaranteeMain.guaranteeDownloadUrl
            : '/zcjf/base/file/download/' +
              guarantee.order?.bfeGuaranteeMain?.electronicGuaranteeFileId,
      }
    },
  },
  methods: {
    serach() {
      if (this.text) {
        this.loading = true

        // 履约保函查验走此接口
        viewPerformanceRecord(this.text).then((res) => {
          if (res.data) {
            this.isPerformance = true
            this.guarantee = res.data
            this.loading = false
            return true
          }
          queryVerifyByGuarantee(this.text).then((res) => {
            this.isPerformance = false
            this.guarantee = res.data
            this.loading = false
          })
        })
      }
    },
  },
  beforeMount() {
    const guaranteeNo = this.$route.query.guaranteeNo
    if (guaranteeNo) {
      this.text = guaranteeNo
      this.serach()
    }
  },
}
</script>

<style scoped>
.verify-wrapper {
  width: 900px;
  margin: 0 auto;
  padding-top: 68px;
  padding-bottom: 20px;
}
.verify-title {
  font-size: 42px;
  line-height: 1;
  color: #3b85f4;
  letter-spacing: 2px;
  text-align: center;
  margin-bottom: 58px;
}
.search-group >>> .el-input__inner {
  height: 88px;
  line-height: 88px;
  border: 1px solid #3b85f4;
  font-size: 20px;
  border-radius: 8px 0 0 8px;
}
.search-group >>> .el-input-group__append {
  width: 128px;
  border-color: #3b85f4;
  background-color: #3b85f4;
  color: #fff;
  font-size: 24px;
  border-radius: 0 8px 8px 0;
  transition: opacity 0.3s;
}
.search-group >>> .el-input-group__append .el-button {
  margin: 0 auto;
}
.search-group >>> .el-input-group__append:active {
  opacity: 0.75;
}
.verify-tip {
  font-size: 14px;
  color: #333;
  margin-top: 23px;
}
.verify-tip .tip-icon {
  font-size: 16px;
  color: #3b85f4;
}
.resultInfo {
  /*background-color: #ffffff;*/
  margin-top: 20px;
}
.verify-wrapper .el-form .el-form-item {
  width: 33.3%;
  display: inline-block;
  vertical-align: top;
  padding: 5px 4% 5px 12px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  margin-bottom: 0;
}
.projectName {
  margin-left: 10px;
  font-size: 14px;
  margin-bottom: 12px;
}
.formDiv {
  background-color: #edf5fa;
  border-radius: 10px;
  margin-bottom: 20px;
  padding: 20px;
}
</style>
